import { Component, Input, OnInit } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { ShippingService } from 'src/app/services/shipping.service';
import { SubjectService } from 'src/app/services/subject.service';

@Component({
  selector: 'app-delete-shipping-address',
  templateUrl: './delete-shipping-address.component.html',
  styleUrls: ['./delete-shipping-address.component.scss']
})
export class DeleteShippingAddressComponent implements OnInit {
@Input() shippingAddress: any;
@Input() userLoggedIn: any;
  constructor(private SS: SubjectService, private modalController:ModalController,
    private SHS:ShippingService) {
   }

  ngOnInit() {
  }

  remove(){
    if(this.userLoggedIn){
      const payload = {accountNumber : this.shippingAddress.id}
      this.SHS.deleteaddress(payload).subscribe(res=>{
        this.SS.refreshAddress.next(true)
        this.dismiss()
      },(e)=>{
      if(e.status == 200){
        this.SS.refreshAddress.next(true)
        this.dismiss()
      }
      })
    }else{
      this.SHS.deleteaddressOnNotLogin().subscribe(res=>{
        this.SS.refreshAddressForNonLoggedIn.next(true)
        this.dismiss()
      },err=>{
        if(err?.status == 200){
          this.SS.refreshAddress.next(true)
          this.dismiss()
        }
      });

    }
  }

  cancel(){
    this.dismiss()
  }
  
  dismiss() {
    // using the injected ModalController this page
    // can "dismiss" itself and optionally pass back data
    this.modalController.dismiss({
      dismissed: true,
    });
  }
}
